import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import loginBoxBg from '../images/bg.jpg';
import HeaderOnlyLogo from '../layout/HeaderOnlyLogo';
import checkMailImg from '../images/check-mail.svg';

export default function CheckYourMail() {

  return (

    
    <section className='page-sign-in' style={{ backgroundImage: `url(${loginBoxBg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      <HeaderOnlyLogo />
      <div className='sign-in-form w-full'>
        <div className='form-card-container w-check-your-mail'>
          <div className='form-body'>
            <div className="chck-mail-icon">
              <img src={checkMailImg} alt="check-mail" />
            </div>
          </div>
          <div className='form-header'>
            <h1 className='form-title'>Check your email</h1>
            <div className='form-description'>Please click the link sent to your email <Link to='javascript:void(0)'>johndoe@onhiring.com</Link> to reset your account. Thank you</div>
          </div>
          <div className='form-body'>
            <div className='form-group'>
              <button type='submit' className='btn-sign-in'>Skip for now</button>
            </div>
          </div>
          <div className='form-header'>
            <div className='form-description'>Didn’t receive an email? <Link to='javascript:void(0)'>Resend</Link></div>
          </div>
        </div>
      </div>
    </section>
  );
}
